 <template>
  <v-card>
    <v-card-title class="headline grey lighten-2" primary-title>
      Currency
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeCurrDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <form data-vv-scope="queryCurrFilterForm">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex lg6 xs12>
                          <v-text-field
                            data-vv-scope="queryCurrFilterForm"
                            v-model="filtersCurr.currency"
                            :label="filtersCurrLabel.currency"
                            :error-messages="errors.collect('filterCurr')"
                            data-vv-name="filterCurr"
                            :data-vv-as="filtersCurrLabel.currency"
                            v-validate="'entry|max:20'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions right>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearCurrFilters(true)">Clear Filters</v-btn>
                    <v-btn color="primary" text @click.prevent="doCurrFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="currHeaders"
          :items="currItems"
          v-bind:options.sync="paginationCurr"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :server-items-length="totalItemsCurr"
          :loading="loading"
          class="elevation-1"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.curr }}</td>
              <td>{{ formatDate(row.item.currEffDate) }}</td>
              <td>{{ row.item.currDesc }}</td>
              <td style="text-align: right">{{ formatDisplayNumber(row.item.currRate, 7) }}</td>
              <td style="text-align: center">
                <v-btn text icon color="primary" type="submit" @click.prevent="assignCurrency(row.item)">
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayNumber } from '@/utils/number'

export default {
  data() {
    return {
      actionName: '',
      filtersCurrLabel: {
        currency: 'Currency'
      },
      filtersCurr: {
        currency: undefined
      },
      currItems: [],
      totalItemsCurr: 0,
      currHeaders: [
        { text: 'Currency', align: 'left', value: 'curr' },
        { text: 'Effective Date', value: 'currEffDate' },
        { text: 'Description', value: 'currDesc' },
        { text: 'Rate', value: 'currRate' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      accountCurrHeaders: [
        { text: 'Currency', align: 'left', value: 'curr' },
        { text: 'Description', value: 'currDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationCurr: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
  },
  methods: {
    closeCurrDialog() {
      this.filtersCurr.currency = ''
      this.$emit('close')
    },
    doClearCurrFilters(toClear) {
      if (toClear === true) {
        this.filtersCurr.currency = null
      }
      this.fetchCurrData()
    },
    doCurrFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryCurrFilterForm').then((result) => {
        if (result) {
          this.paginationCurr.page = 1
          this.fetchCurrData()
        }
      })
    },
    assignCurrency(data) {
      // Use $emit to call parent Accounts page method assignCurrency and pass the value
      this.$emit('assign-currency-info', data)
      this.$emit('assign-currency', data.curr)
      this.$emit('close')
    },
    formatDisplayNumber(val, scale) {
      return formatDisplayNumber(val, scale)
    }
  },
  computed: {},
  watch: {
    'paginationCurr': function (value) {
      this.doClearCurrFilters()
    },
    boolRefresh: function(value) {
      if (value) {
        this.doClearCurrFilters()
      }
    }
  },
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
